import { useContext } from 'react';

import PayloadRawMaterialContext from '../../context/materialcapture/PayloadRawMaterialContext';

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import SendSharpIcon from '@mui/icons-material/SendSharp';

const PayloadRawMaterialForm = () => {
  const { 
    payloadRawData, setPayloadRawData, handleSubmit, initialValues, formErrors
  } = useContext(PayloadRawMaterialContext);

  return(
    <Grid container spacing={1} mt={1}>
      <Grid item xs={6}>
        <Autocomplete
          value={payloadRawData?.payloadName}
          onChange={(e, newValue) => 
            setPayloadRawData(prev => ({
              ...prev,
              payloadName: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setPayloadRawData(prev => ({
              ...prev,
              payloadName: newValue
            }))
          }
          options={initialValues?.payloadNameArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Payload Name *" 
              placeholder="Type to search Payload Name..." 
              error={'payloadName' in formErrors}
              helperText={formErrors['payloadName']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={payloadRawData?.payloadType}
          onChange={(e, newValue) => 
            setPayloadRawData(prev => ({
              ...prev,
              payloadType: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setPayloadRawData(prev => ({
              ...prev,
              payloadType: newValue
            }))
          }
          options={initialValues?.payloadTypeArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Payload Type *" 
              placeholder="Type to search payload Type..." 
              error={'payloadType' in formErrors}
              helperText={formErrors['payloadType']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={payloadRawData?.reporter}
          onChange={(e, newValue) => 
            setPayloadRawData(prev => ({
              ...prev,
              reporter: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setPayloadRawData(prev => ({
              ...prev,
              reporter: newValue
            }))
          }
          options={initialValues?.reporterArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Reporter *" 
              placeholder="Type to search Reporter..." 
              error={'reporter' in formErrors}
              helperText={formErrors['reporter']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={payloadRawData?.payloadBatchNumber}
          onChange={(e, newValue) => 
            setPayloadRawData(prev => ({
              ...prev,
              payloadBatchNumber: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setPayloadRawData(prev => ({
              ...prev,
              payloadBatchNumber: newValue
            }))
          }
          options={initialValues?.payloadBatchNumberArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Payload Batch Number *" 
              placeholder="Type to search Payload Batch Number..." 
              error={'payloadBatchNumber' in formErrors}
              helperText={formErrors['payloadBatchNumber']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Concentration (mg/mL) *"
          name='concentration'
          value={payloadRawData?.concentration}
          onChange={e => 
            setPayloadRawData(prev => ({
              ...prev,
              concentration: e.target.value
            }))
          }
          helperText={formErrors['concentration']}
          error={'concentration' in formErrors}
          type='number'
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          multiple
          freeSolo
          fullWidth
          value={payloadRawData?.operatorArray || []}
          onChange={(e, newValue) => 
            setPayloadRawData(prev => ({
              ...prev,
              operatorArray: newValue
            }))
          }
          onInputChange={(e, newInputValue, reason) => {
            if (reason === "createOption" && newInputValue.trim()) {
              setPayloadRawData((prev) => ({
                ...prev,
                operatorArray: [
                  ...(prev.operatorArray || []),
                  newInputValue
                ],
              }));
            }
          }}
          options={initialValues?.operatorArray || []}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Operator *" 
              placeholder="Type to search Operator..." 
              error={'operator' in formErrors}
              helperText={formErrors['operator']}
            />
          )}
        />
      </Grid>
      
      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Molecular weight (g/mol) *"
          name='molecularWeight'
          value={payloadRawData?.molecularWeight}
          onChange={e =>
            setPayloadRawData(prev => ({
              ...prev,
              molecularWeight: e.target.value
            }))
          }
          type='number'
          helperText={formErrors['molecularWeight']}
          error={'molecularWeight' in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={payloadRawData?.storageBufferId}
          onChange={(e, newValue) => 
            setPayloadRawData(prev => ({
              ...prev,
              storageBufferId: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setPayloadRawData(prev => ({
              ...prev,
              storageBufferId: newValue
            }))
          }
          options={initialValues?.bufferUniqueIdArray.map(data => data.unique_id)}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Storage Buffer Unique ID *" 
              placeholder="Type to search Buffer Unique ID..." 
              error={'storageBufferId' in formErrors}
              helperText={formErrors['storageBufferId']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Storage Buffer Acronym"
          name='storageBufferAcronym'
          value={payloadRawData?.storageBufferAcronym}
          fullWidth
          disabled
        />
      </Grid>

      <Grid item xs={12}>
        <Stack direction="row" spacing={1} justifyContent="flex-end" mr={1}>
          <Button 
            variant="contained" 
            endIcon={<SendSharpIcon />} 
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default PayloadRawMaterialForm;